const TmpL011 = (page) => {
  const eMentors = [];
  const modifiedPage = {
    ...page,
    
  };

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id,
      };
      eMentors.push(eMentor);
    });
  } 

  // Extract metadata separately
  const metadata = {
    media: [],
    images: [],
    materials: [],
    eMentor: eMentors,
    focusPoints: [],
  };

  return { modifiedPage, metadata };
};

export default TmpL011;